/*external modules*/
/*types*/
/*utils*/
/*lib*/
/*other*/

function isUndefined(value: unknown): value is undefined {
  return value === undefined;
}

export default isUndefined;
